import { render } from "./AskPopUp.vue?vue&type=template&id=e58f6f4e"
import script from "./AskPopUp.vue?vue&type=script&lang=js"
export * from "./AskPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__